import React, { forwardRef } from 'react'
import ListItem from '@mui/material/ListItem'
import { NavLink } from 'react-router-dom'

const AppMenuItemComponent = props => {
  const { className, onClick, link, children, state, active, parentActive } = props

  // Grupo (sem link): ListItem puro. Marca "seção atual" (active-parent) quando algum descendente
  // é a rota ativa — antes era impossível porque não havia NavLink aqui.
  if (!link || typeof link !== 'string') {
    return (
      <ListItem
        button
        className={parentActive ? `${className} active-parent` : className}
        children={children}
        onClick={onClick}
      />
    )
  }

  // Folha/link: mantém o NavLink (navegação), mas o "ativo" agora é decidido pelo MATCHER via
  // isActive (não mais pelo `exact` do pathname). Assim subrotas/telas de detalhe também marcam.
  return (
    <ListItem
      button
      className={className}
      children={children}
      component={forwardRef((navProps, ref) => (
        <NavLink
          to={{ pathname: link, state: state }}
          isActive={() => !!active}
          {...navProps}
          innerRef={ref}
        />
      ), [link, active])}
    />
  )
}

export default AppMenuItemComponent
